// extracted by mini-css-extract-plugin
export default {"cardsContainer":"StudentSuccess_cardsContainer__tDN1B"};